<canvas id="barline-{{id}}"></canvas>
